import {defineRouting} from 'next-intl/routing';
import {i18nConfig} from '../../next-i18next.config';

export const routing = defineRouting({
    locales: i18nConfig.locales,
    defaultLocale: i18nConfig.defaultLocale,

    localePrefix: 'always',
    pathnames: {
        'over-mkg': {
            en: 'about-mkg',
            de: 'ueber-mkg'
        },
        'verspaning':{
            en: 'machining',
            de: 'zerspanung'
        },
        'plaatwerk':{
            en: 'sheet-metal-work',
            de: 'blechbearbeitung'
        },
        'oppervlaktebehandeling':{
            en: 'surface-treatment',
            de: 'oberflächenbehandlung'
        },
        'las-en-constructiewerk':{
            en: 'welding-and-construction',
            de: 'schweiss-und-konstruktionsarbeiten'
        },
        'machinebouw-en-assemblage':{
            en: 'machinebuilding-and-assembly',
            de: 'maschinenbau-und-montage'
        },
        'gereedschapmakerij':{
            en: 'tool-making',
            de: 'werkzeugbau'
        },
        "mkg-nieuwsoverzicht":{
            en: 'mkg-newsoverview',
            de: 'mkg-newsübersicht'
        },
        "mkg5-erp-systeem":{
            en: 'mkg5-erp-system',
            de: 'mkg5-erp-system'
        },
        "mkg5-erp-pakket":{
            en: 'mkg5-erp-package',
            de: 'mkg5-erp-paket'
        },
        "mijn-mkg": {
            en: "my-mkg",
            de: "mein-mkg"
        },
        "support": {
            en: "support",
            de: "hilfe"
        },
        "nieuw":{
            en: "new",
            de: "neu"
        },
        "landingspagina":{
            en: "landingpage",
            de: "landingpage"
        },
        "storingen": {
            en: "report-issue",
            de: "stoerung-melden"
        },

        "nieuwste-versie": {
            en: "latest-version",
            de: "neueste-version"
        },
        "beheer":{
            en: "management",
            de: "management"
        },
        "mijn-gegevens":{
            en: "my-data",
            de: "mein-daten"
        },
        "gebruikersbeheer":{
            en: "user-management",
            de: "benutzerverwaltung"
        },
        "meldingenbeheer":{
            en: "incident-management",
            de: "vorfallmanagement"
        },
        "melding":{
            en: "incident",
            de: "vorfall"
        },
        "aanmaken":{
            en: "create",
            de: "erstellen"
        },
        "activiteiten":{
            en: "activities",
            de: "activitaten"
        },

        "reserveringsplanner": {
            "en": "reservation-planner",
            "de": "Reservierungsplaner"
        },

        "content-management": {
            "en": "content-management",
            "de": "inhaltsverwaltung"
        },
        "producten-versies": {
            "en": "product-versions",
            "de": "produktversionen"
        },

        "categorie": {
            "en": "category",
            "de": "kategorie"
        },
        "cursus-tenants":{
            "en": "course-tenants",
            "de": "kurs-mandanten"
        },
        "kenniscentrum": {
            "en": "knowledge-center",
            "de": "wissenszentrum"
        },
        "cursussen": {
            "en": "courses",
            "de": "kurse"
        },
        "cursus-beheer": {
            "en": "course-management",
            "de": "kursverwaltung"
        },
        "tags": {
            "en": "tags",
            "de": "schlagworte"
        },
        "taggroep-beheer": {
            "en": "tag-group-management",
            "de": "schlaggruppverwaltung"
        },
        "media": {
            "en": "media",
            "de": "medien"
        },
        "tekst-fragmenten": {
            "en": "text-fragments",
            "de": "textfragmente"
        },
        "talen": {
            "en": "languages",
            "de": "sprachen"
        },

        "uren": {
            "en": "hours",
            "de": "stunden"
        },
        "producten": {
            "en": "products",
            "de": "produkte"
        },
        "daglicentie":{
            "en": "day-license",
            "de": "tagelicense"
        },
        "uitloggen": {
            "en": "logout",
            "de": "abmelden"
        },
        "systeembeheer":{
            "en": "system-administration",
            "de": "systemverwaltung"
        },
        "instellingen":{
            "en": "settings",
            "de": "einstellungen"
        },
        "bedrijfsdoelen":{
            "en": "company-goals",
            "de": "unternehmensziele"
        },
        "nieuws":{
            "en": "news",
            "de": "nachrichten"
        },
        "branches":{
            "en": "industries",
            "de": "branchen"
        },
        "metadata": {
            "en": "metadata",
            "de": "metadaten"
        }
    }

});
export const pathTranslations = routing.pathnames;
export const reverseSegmentTranslations = {};

for (const [segment, translations] of Object.entries(pathTranslations)) {
    for (const [lang, translatedSegment] of Object.entries(translations)) {
        if (!reverseSegmentTranslations[lang]) reverseSegmentTranslations[lang] = {};
        reverseSegmentTranslations[lang][translatedSegment] = segment;
    }
}
export const reverseSegmentTranslationsFallback = {};

for (const translations of Object.values(pathTranslations)) {
    for (const translatedSegment of Object.values(translations)) {
        reverseSegmentTranslationsFallback[translatedSegment] = true; // or store original if needed
    }
}
